module.exports = __webpack_public_path__ + "media/images/massage-235ff4536a2523c0eca3477fac8543c6.svg";